(function () {
  EASY.search = EASY.search || (EASY.search = {});

  $.widget("easy.catcomplete", $.ui.autocomplete, {
    _create: function () {
      this._super();
      this.widget().menu("option", "items", "> :not(.ui-autocomplete-category)");
      // this.element.attr( "autocomplete", "nope" );
    },
    _renderMenu: function (ul, items) {
      var currentCategory = "";
      $.each(items, (index, item) => {
        var li;
        if (item.category != currentCategory && item.category != undefined) {
          ul.append("<li class='ui-autocomplete-category'>" + item.category + "</li>");
          currentCategory = item.category;
        }
        li = this._renderItemData(ul, item);
        if (item.category) {
          li.attr("aria-label", item.category + " : " + item.label);
        }
      });
    },
  });
})();
